var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gooimeer"}},[_c('b-container',{staticClass:"calculator"},[_c('b-row',{staticClass:"mt-3 mb-5"},[_c('b-col',{staticClass:"text-right"},[_c('img',{attrs:{"width":"50%","src":require("./assets/HoeschLogo.png"),"alt":"Logo Hoesch","title":"Logo Hoesch"}})])],1)],1),_vm._v(" "),_c('Calculator',{attrs:{"layout":"hoesch","languages":_vm.languages}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9df40d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Hoesch.vue
// module id = 567
// module chunks = 0